import { Component } from '@angular/core';

@Component({
    selector: 'shared-offlinemode',
    templateUrl: './offlinemode.component.html',
    styleUrls: ['./offlinemode.component.scss'],
    standalone: false
})
export class OfflinemodeComponent {}
